import { createFileRoute, Link } from "@tanstack/react-router";
import { PortalShell, ProjectCard } from "@/components/business/B2BPortal";
import { SEOHead } from "@/components/shared/SEOHead";
import {
  productByIdFromSnapshot,
  quoteForProjectFromSnapshot,
  useBusinessPortalSnapshot,
} from "@/lib/b2bPortalApi";

export const Route = createFileRoute("/business/portal/projects")({
  component: ProjectsPage,
});

function ProjectsPage() {
  const portal = useBusinessPortalSnapshot();
  const { account, catalog, projects, quotes } = portal.data;
  const quoteReviewCount = quotes.filter((quote) => quote.status === "sent").length;
  const proofCount = projects.filter((project) => project.placement.safeAreaValid).length;

  return (
    <PortalShell
      active="/business/portal/projects"
      eyebrow="Projects"
      title="Proofs and quotes"
      description="Review packaging work before it moves into production."
      account={account}
      actions={(
        <>
          <button type="button" className="b2b-secondary-button" onClick={() => void portal.refresh()}>
            Refresh
          </button>
          <Link to="/business/portal/projects/new" className="b2b-primary-button">
            New project
          </Link>
        </>
      )}
    >
      <SEOHead title="Packaging Projects" description="Manage Quuil B2B packaging projects." path="/business/portal/projects" robots="noindex,follow" />

      <section className="b2b-three-column">
        <article className="b2b-card b2b-mini-card">
          <span className="b2b-kicker">Catalog</span>
          <strong>{catalog.length}</strong>
          <p>Items available.</p>
        </article>
        <article className="b2b-card b2b-mini-card">
          <span className="b2b-kicker">Quotes</span>
          <strong>{quoteReviewCount}</strong>
          <p>Ready to review.</p>
        </article>
        <article className="b2b-card b2b-mini-card">
          <span className="b2b-kicker">Proofs</span>
          <strong>{proofCount}</strong>
          <p>Ready for quote.</p>
        </article>
      </section>

      {portal.loading ? (
        <section className="b2b-card-grid">
          {["A", "B"].map((item) => (
            <article key={item} className="b2b-card b2b-loading-card">
              <div />
              <div />
              <div />
            </article>
          ))}
        </section>
      ) : projects.length > 0 ? (
        <section className="b2b-card-grid">
          {projects.map((project) => (
            <ProjectCard
              key={project.id}
              project={project}
              product={productByIdFromSnapshot(portal.data, project.productId)}
              quote={quoteForProjectFromSnapshot(portal.data, project.id)}
            />
          ))}
        </section>
      ) : (
        <section className="b2b-card b2b-empty-state">
          <h2>No projects yet</h2>
          <p>Start an order from your catalog to create the first proof and quote.</p>
          <Link to="/business/portal/projects/new" className="b2b-primary-button">
            Start order
          </Link>
        </section>
      )}
    </PortalShell>
  );
}
